export default __webpack_public_path__ + "static/media/out-1.dc3dfe06.png";